import classes from './Loading-Spinner.module.css';
import ReactDOM from 'react-dom';
import { Fragment } from 'react';
import { FadeLoader } from 'react-spinners';

const Backdrop = () => {
  return <div className={classes.backdrop} />;
};

const LoadingSpinner = (props) => {
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop />,
        document.getElementById('backdrop-root')
      )}
      {ReactDOM.createPortal(
        <div className={`${classes.modal}`}>
          <FadeLoader className="m-auto" color="#36d7b7" />
          <div className="text-white text-center">
            {props.loadingText ??
              'Backed server is starting up.....Please revisit 2-3 mins later'}
          </div>
        </div>,
        document.getElementById('overlay-root')
      )}
    </Fragment>
  );
};

export default LoadingSpinner;
